// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-nlVD","spin":"styles_spin__EWP4w"};